/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useState } from 'react';
import {
    arrayOf, number, object, shape, string, func, array, bool,
} from 'prop-types';
import {
    FormControl,
    Grid, NativeSelect, Button,
} from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import Input from '@material-ui/core/Input';
import SubcollectionMobileHeader from './SubcollectionMobileHeader';
import SubCollectionV2Collection from '../SubCollectionV2Collection';
import PassportEyebrow from '../../../PassportBanner/PassportEyebrow';
import SubCollectionBrandsDropDown from '../SubCollectionBrandsDropDown';

const styles = (theme) => ({
    mobileSelectedTag: {
        margin: '10px 0px 0px 0px',
        '& .MuiNativeSelect-select.MuiNativeSelect-select': {
            background: theme.palette?.cms?.activeButtonColor || '#E8F1ED',
            border: `1px solid ${theme.palette.cms?.black || '#333'}`,
            textAlign: 'center',
            textIndent: '10%',
            width: '214px',
        },
        '& .MuiTouchRipple-child': {
            background: 'transparent',
        },
        '& .MuiButtonBase-root:hover': {
            backgroundColor: theme.palette?.cms?.activeButtonColor || '#E8F1ED',
        },
    },
    mobilePassportBanner: {
        margin: '10px 0px 10px 0px',
    },
    levelOneTag: {
        margin: '10px 0px 15px 0px',
        '& .MuiButtonBase-root': {
            fontSize: 9,
            textTransform: 'uppercase',
            padding: '0 10px',
            color: '#cccccc',
            borderLeft: '1px solid #cccccc',
            borderRadius: 0,
            lineHeight: 1,
        },
        '& .MuiButtonBase-root:first-child': {
            paddingLeft: 5,
            borderLeft: 0,
        },
        '& .MuiTouchRipple-child': {
            background: 'transparent',
        },
        '& .MuiButtonBase-root:hover': {
            backgroundColor: 'transparent',
        },
    },
    activeLevelOneTag: {
        '&.MuiButtonBase-root span': {
            color: '#222222',
        },
    },
    levelTwoTag: {
        margin: '0px 0px 10px 0px',
        '& .MuiNativeSelect-select.MuiNativeSelect-select': {
            background: theme.palette?.cms?.activeButtonColor || '#F1EDEE',
            border: `1px solid ${theme.palette.cms?.black || '#DCDCDC'}`,
            borderRadius: 15,
            textAlign: 'center',
            padding: '15px 40px 15px 40px',
            lineHeight: 1,
        },
        '& .MuiTouchRipple-child': {
            background: 'transparent',
        },
        '& .MuiButtonBase-root:hover': {
            backgroundColor: theme.palette?.cms?.activeButtonColor || '#E8F1ED',
        },
        '& .MuiNativeSelect-icon': {
            right: 12,
        },
    },
    hideArrowIcon: {
        display: 'none',
    },
});

const  SubcollectionV2Mobile = ({
    classes, data, track, prefetched, isVariant, prefetchedCollectionIds, listOfBrands,
}) => {
    const prefetch = prefetched !== null;
    const [collectionId, setCollectionId] = useState(prefetch ? prefetchedCollectionIds[0] : data?.collection_sources?.collection?.[0]?.collection_id);
    const [brandSelection, setBrandSelection] = useState(0);
    const collectionData = data?.collection_sources?.collection || [];
    // on click change brand tab
    const handleBrandChange = (index) => {
        setBrandSelection(index);
        setCollectionId(prefetchedCollectionIds[index]);
    };

    if (prefetch && isVariant) {
        const collectionIds = collectionData[brandSelection].collection_id.split(', ');
        const buttonTextAvailable = collectionData[brandSelection].source.split(', ');
        const newCollection = [];
        for (let index = 0; index < collectionIds.length; index += 1) {
            newCollection[index] = {
                collection_id: collectionIds[index],
                source: buttonTextAvailable[index],
                tracking: collectionData[brandSelection].tracking,
            };
        }
        return (
            <Grid contanier>
                <Grid item xs={12}>
                    <SubcollectionMobileHeader
                        eventEyebrow={data?.event_eyebrow}
                        viewAllButton={data?.cta_link}
                        headingCopy={data?.heading_copy}
                        headingFontFaimly={data?.heading_font}
                        headingFontColor={data?.heading_font_color?.color}
                        headingFontSize={data?.heading_font_size}
                        parentBrands={data?.product_parent_pbrands}
                        showEyeBrow={data?.show_passport_eyebrow}
                    />
                </Grid>
                <Grid item xs={12}>
                    <Grid container>
                        { listOfBrands && (
                            <Grid item xs={12} sm={12} md={7} className={classes.levelOneTag}>
                                {listOfBrands?.map((linkItem, index) => (
                                    <Button className={index === brandSelection && classes.activeLevelOneTag} onClick={() => { handleBrandChange(index); }}>{linkItem}</Button>
                                ))}
                            </Grid>
                        )}
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Grid container>
                        {buttonTextAvailable  && (
                            <Grid item xs={12} md={6} className={classes.levelTwoTag}>
                                <FormControl>
                                    <NativeSelect
                                        disableUnderline
                                        value={collectionId}
                                        onChange={(e) => {
                                            const tracking = newCollection?.find?.((item) => item?.collection_id === e.target.value)?.tracking || {};
                                            track({
                                                eventCategory: tracking?.tracking_event_category || '',
                                                eventAction: tracking?.tracking_event_action || '',
                                                eventLabel: tracking?.tracking_event_label || '',
                                            });
                                            setCollectionId(e.target.value);
                                        }}
                                        classes={{
                                            root: classes.selectMarginTop,
                                            select: classes.select,
                                            icon: collectionIds.length > 1 ? classes.arrowIcon : classes.hideArrowIcon,
                                        }}
                                        input={(
                                            <Input
                                                name="subcollectionList"
                                                id="subcollection-label-placeholder"
                                                classes={{
                                                    root: classes.inputMarginTop,
                                                }}
                                            />
                                        )}
                                    >
                                        {newCollection?.map((linkItem) => (
                                            <option
                                                value={linkItem?.collection_id}
                                                key={linkItem?.collection_id}
                                            >
                                                {linkItem?.source}
                                            </option>
                                        ))}
                                    </NativeSelect>
                                </FormControl>
                            </Grid>
                        )}
                        <Grid item xs={12} md={6} className={classes.mobilePassportBanner}>
                            {data?.show_passport_eyebrow && <PassportEyebrow />}
                        </Grid>
                    </Grid>
                </Grid>
                <SubCollectionV2Collection
                    collectionId={collectionId}
                    numberofMobileProduct={data?.number_of_product_for_mobile}
                    numberOfProducts={data?.number_of_products}
                    prefetched={prefetched[collectionId] || []}
                    track={{
                        track,
                        category: data?.collection_sources?.products_tracking?.tracking_event_category || '',
                        action: data?.collection_sources?.products_tracking?.tracking_event_action || {},
                    }}
                />
            </Grid>
        );
    }

    const findButtonText = collectionData?.some((item) => item?.source);
    return (
        <Grid contanier>
            <Grid item xs={12}>
                <SubcollectionMobileHeader
                    eventEyebrow={data?.event_eyebrow}
                    viewAllButton={data?.cta_link}
                    headingCopy={data?.heading_copy}
                    headingFontFaimly={data?.heading_font}
                    headingFontColor={data?.heading_font_color?.color}
                    headingFontSize={data?.heading_font_size}
                    parentBrands={data?.product_parent_pbrands}
                    showEyeBrow={data?.show_event_eyebrow}
                />
            </Grid>
            <Grid item xs={12}>
                <Grid container>
                    {findButtonText  && (
                        <Grid item xs={12} md={6}>
                            <SubCollectionBrandsDropDown
                                collectionData={collectionData}
                                collectionId={collectionId}
                                setCollectionId={setCollectionId}
                                track={track}
                            />
                        </Grid>
                    )}
                    <Grid item xs={12} md={6} className={classes.mobilePassportBanner}>
                        {data?.show_passport_eyebrow && <PassportEyebrow />}
                    </Grid>
                </Grid>
            </Grid>
            <SubCollectionV2Collection
                collectionId={collectionId}
                numberofMobileProduct={data?.number_of_product_for_mobile}
                numberOfProducts={data?.number_of_products}
                track={{
                    track,
                    category: data?.collection_sources?.products_tracking?.tracking_event_category || '',
                    action: data?.collection_sources?.products_tracking?.tracking_event_action || {},
                }}
            />
        </Grid>
    );
};

SubcollectionV2Mobile.propTypes = {
    classes: object.isRequired,
    data: shape({
        title: string,
        reference: arrayOf(shape({
            celebration_passport_text: shape({
                celebration_text: string,
                passport_text: string,
            }),
            event_eyebrow: shape({
                copy_block: string,
                reminder_text: string,
                background_color: shape({
                    color: string,
                }),
            }),
            heading_copy: string,
            heading_font: string,
            heading_font_size: number,
        })),
    }),
    track: func,
    isVariant: bool.isRequired,
    prefetched: object.isRequired,
    prefetchedCollectionIds: array.isRequired,
    listOfBrands: array.isRequired,
};
SubcollectionV2Mobile.defaultProps = {
    data: {},
    track: () => { },
};
export default  withStyles(styles)(SubcollectionV2Mobile);
